(function(){
  var section = document.querySelector('[data-filiera]');
  if (!section) return;

  var canvas = section.querySelector('.filiera-canvas');
  var frameEl = section.querySelector('.filiera-frame');
  var panel = section.querySelector('.filiera-panel');
  var panelClose = panel.querySelector('.filiera-panel__close');
  var panelMedia = panel.querySelector('.filiera-panel__media');
  var desktopHint = section.querySelector('.filiera-hint');
  var photo = section.querySelector('.filiera-canvas > .photo');
  var wc = section.querySelector('.filiera-canvas > .watercolor');
  var muteLabel = section.dataset.muteLabel, unmuteLabel = section.dataset.unmuteLabel;
  var IMG_W = 1440, IMG_H = 750;
  var hotspots = Array.prototype.slice.call(section.querySelectorAll('.filiera-hotspots .filiera-hotspot'));
  var isDetail = false;
  var panelMediaResizeObserver = null;
  var soundToggleIcons = '<svg class="filiera-sound-icon filiera-sound-icon--off" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 9v6h4l5 4V5L8 9H4Z" fill="currentColor"/><path d="m17 9 4 4m0-4-4 4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg><svg class="filiera-sound-icon filiera-sound-icon--on" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 9v6h4l5 4V5L8 9H4Z" fill="currentColor"/><path d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

  function setupMuteButton(button, video) {
    button.innerHTML = soundToggleIcons;

    function updateMuteButton() {
      var isMuted = video.muted;
      button.classList.toggle('is-muted', isMuted);
      button.setAttribute('aria-pressed', String(!isMuted));
      button.setAttribute('aria-label', isMuted ? unmuteLabel : muteLabel);
    }

    button.addEventListener('click', function () {
      video.muted = !video.muted;
      if (!video.muted) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
      }
      updateMuteButton();
    });
    video.addEventListener('volumechange', updateMuteButton);
    updateMuteButton();
  }

  function playInlineMuted(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function coverPct(fx, fy, bw, bh) {
    var scale = Math.max(bw / IMG_W, bh / IMG_H);
    var dispW = IMG_W * scale, dispH = IMG_H * scale;
    var offX = (bw - dispW) / 2, offY = (bh - dispH) / 2;
    return { leftPct: ((offX + fx * dispW) / bw) * 100, topPct: ((offY + fy * dispH) / bh) * 100 };
  }

  function positionHotspots() {
    if (getComputedStyle(section.querySelector('.filiera-stage')).display === 'none') return;
    var bw = canvas.clientWidth, bh = canvas.clientHeight;
    if (!bw || !bh) return;
    hotspots.forEach(function (hs) {
      var fx = parseFloat(hs.dataset.fx) / 100, fy = parseFloat(hs.dataset.fy) / 100;
      var p = coverPct(fx, fy, bw, bh);
      hs.style.left = p.leftPct + '%'; hs.style.top = p.topPct + '%';
    });
  }
  window.addEventListener('resize', positionHotspots);
  positionHotspots();

  /* Desktop panorama: drag horizontally only when the full image overflows. */
  var panoramaDragging = false, panoramaMoved = false, panoramaHintDismissed = false;
  var panoramaStartX = 0, panoramaStartScrollLeft = 0;

  function updateDesktopPanorama(preservePosition) {
    if (getComputedStyle(section.querySelector('.filiera-stage')).display === 'none') return;
    var oldMax = frameEl.scrollWidth - frameEl.clientWidth;
    var oldProgress = oldMax > 0 ? frameEl.scrollLeft / oldMax : 0.5;

    requestAnimationFrame(function () {
      var max = Math.max(0, frameEl.scrollWidth - frameEl.clientWidth);
      frameEl.classList.toggle('is-scrollable', max > 1);
      desktopHint.classList.toggle('is-visible', max > 1 && !panoramaHintDismissed);
      desktopHint.setAttribute('aria-hidden', max > 1 && !panoramaHintDismissed ? 'false' : 'true');
      frameEl.scrollLeft = max * (preservePosition ? oldProgress : 0.5);
      positionHotspots();
    });
  }

  frameEl.addEventListener('pointerdown', function (e) {
    if (isDetail || e.pointerType === 'touch' || frameEl.scrollWidth <= frameEl.clientWidth + 1) return;
    panoramaDragging = true;
    panoramaMoved = false;
    panoramaStartX = e.clientX;
    panoramaStartScrollLeft = frameEl.scrollLeft;
  });

  frameEl.addEventListener('pointermove', function (e) {
    if (!panoramaDragging) return;
    var delta = e.clientX - panoramaStartX;
    if (!panoramaMoved && Math.abs(delta) > 4) {
      panoramaMoved = true;
      panoramaHintDismissed = true;
      desktopHint.classList.remove('is-visible');
      desktopHint.setAttribute('aria-hidden', 'true');
      frameEl.classList.add('is-dragging');
      frameEl.setPointerCapture(e.pointerId);
    }
    frameEl.scrollLeft = panoramaStartScrollLeft - delta;
    if (panoramaMoved) e.preventDefault();
  });

  function stopDesktopPanoramaDrag(e) {
    if (!panoramaDragging) return;
    panoramaDragging = false;
    frameEl.classList.remove('is-dragging');
    if (frameEl.hasPointerCapture(e.pointerId)) frameEl.releasePointerCapture(e.pointerId);
  }

  window.addEventListener('pointerup', stopDesktopPanoramaDrag);
  window.addEventListener('pointercancel', stopDesktopPanoramaDrag);
  frameEl.addEventListener('click', function (e) {
    if (!panoramaMoved) return;
    e.preventDefault();
    e.stopPropagation();
    panoramaMoved = false;
  }, true);

  window.addEventListener('resize', function () { updateDesktopPanorama(true); });
  updateDesktopPanorama(false);

  function updateScroll() {
    if (isDetail || getComputedStyle(section.querySelector('.filiera-stage')).display === 'none') return;
    var rect = section.getBoundingClientRect(), vh = window.innerHeight;
    var range = section.offsetHeight - vh;
    var p = Math.max(0, Math.min(1, -rect.top / range));
    var eased = p * p * (3 - 2 * p);
    wc.style.opacity = eased.toFixed(3);
    photo.style.opacity = (1 - eased * 0.85).toFixed(3);
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(function () { updateScroll(); ticking = false; }); ticking = true; }
  }, { passive: true });
  window.addEventListener('resize', updateScroll);
  updateScroll();

  function fillPanelMedia(zone) {
    var tpl = section.querySelector('template[data-filiera-media="' + zone + '"]');
    if (panelMediaResizeObserver) {
      panelMediaResizeObserver.disconnect();
      panelMediaResizeObserver = null;
    }
    panelMedia.querySelectorAll('video').forEach(function (video) { video.pause(); });
    panelMedia.replaceChildren();

    if (tpl && tpl.content.firstElementChild) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      panelMedia.hidden = false;

      if (node.tagName === 'VIDEO') {
        var videoWrapper = document.createElement('div');
        videoWrapper.className = 'filiera-panel__video-wrapper';

        var panelMute = document.createElement('button');
        panelMute.type = 'button';
        panelMute.className = 'filiera-panel__mute';
        setupMuteButton(panelMute, node);

        videoWrapper.appendChild(node);
        videoWrapper.appendChild(panelMute);
        panelMedia.appendChild(videoWrapper);
        playInlineMuted(node);

        function sizeVideoWrapper() {
          var videoWidth = node.videoWidth || Number(node.getAttribute('width'));
          var videoHeight = node.videoHeight || Number(node.getAttribute('height'));
          var availableWidth = panelMedia.clientWidth;
          var availableHeight = panelMedia.clientHeight;
          if (!videoWidth || !videoHeight || !availableWidth || !availableHeight) return;

          var scale = Math.min(availableWidth / videoWidth, availableHeight / videoHeight);
          videoWrapper.style.width = (videoWidth * scale) + 'px';
          videoWrapper.style.height = (videoHeight * scale) + 'px';
        }

        node.addEventListener('loadedmetadata', sizeVideoWrapper, { once: true });
        if ('ResizeObserver' in window) {
          panelMediaResizeObserver = new ResizeObserver(sizeVideoWrapper);
          panelMediaResizeObserver.observe(panelMedia);
        }
        requestAnimationFrame(sizeVideoWrapper);
      } else {
        panelMedia.appendChild(node);
      }
    } else { panelMedia.hidden = true; }
  }

  var ZOOM = 1.8, savedOverflow = '';
  function openDetail(hotspot) {
    if (isDetail) return;
    
    
    let bcr = document.querySelector('.filiera-section').getBoundingClientRect();
    let offsetY = 0;

    if(bcr.top > 0) {
      offsetY = -bcr.top;
      window.scrollBy({
        top: bcr.top,
        behavior: 'smooth'
      });
    } else if(bcr.bottom < window.innerHeight) {
      offsetY = window.innerHeight - bcr.bottom;
      window.scrollBy({
        top: bcr.bottom - window.innerHeight,
        behavior: 'smooth'
      });
    }
    
    
    isDetail = true;
    section.classList.add('is-detail');
    hotspots.forEach(function (h) { h.classList.remove('is-active'); });
    hotspot.classList.add('is-active');
    panel.querySelector('.filiera-panel__eyebrow').textContent = hotspot.dataset.eyebrow || '';
    panel.querySelector('.filiera-panel__title').textContent = hotspot.dataset.title || '';
    panel.querySelector('.filiera-panel__body').textContent = hotspot.dataset.body || '';
    fillPanelMedia(hotspot.dataset.zone);
    panel.setAttribute('aria-hidden', 'false');

    if (window.gsap) {
      var rect = canvas.getBoundingClientRect();
      var fx = parseFloat(hotspot.dataset.fx) / 100, fy = parseFloat(hotspot.dataset.fy) / 100;
      var p = coverPct(fx, fy, rect.width, rect.height);
      var focalX0 = rect.left + (p.leftPct / 100) * rect.width, focalY0 = rect.top + (p.topPct / 100) * rect.height;
      var panelW = parseFloat(getComputedStyle(section).getPropertyValue('--panel-w')) || 480;
      var visibleW = window.innerWidth - panelW;
      var tx = visibleW / 2 - focalX0, ty = window.innerHeight * 0.55 - focalY0;
      gsap.set(canvas, { transformOrigin: p.leftPct + '% ' + p.topPct + '%' });
      savedOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
      var tl = gsap.timeline({ defaults: { ease: 'power3.inOut' } });
      tl.to(canvas, { scale: ZOOM, x: tx, y: ty, duration: 1.15 }, 0)
        .to(canvas, { '--inv-zoom': 1 / ZOOM, duration: 1.15 }, 0)
        .to(panel, { x: 0, duration: 1.0, ease: 'power3.out' }, 0.15);
    } else { panel.style.transform = 'translateX(0)'; }
  }

  function closeDetail() {
    if (!isDetail) return;
    isDetail = false;
    panelMedia.querySelectorAll('video').forEach(function (video) { video.pause(); });
    section.classList.remove('is-detail');
    panel.setAttribute('aria-hidden', 'true');
    hotspots.forEach(function (h) { h.classList.remove('is-active'); });
    if (window.gsap) {
      var tl = gsap.timeline({ defaults: { ease: 'power3.inOut' }, onComplete: function () { document.body.style.overflow = savedOverflow; gsap.set(canvas, { transformOrigin: '50% 50%' }); } });
      tl.to(panel, { x: '100%', duration: 0.7, ease: 'power3.in' }, 0)
        .to(canvas, { scale: 1, x: 0, y: 0, duration: 1.0 }, 0.05)
        .to(canvas, { '--inv-zoom': 1, duration: 1.0 }, 0.05);
    } else { panel.style.transform = 'translateX(100%)'; }
  }

  hotspots.forEach(function (h) { h.addEventListener('click', function (e) { e.preventDefault(); openDetail(h); }); });
  panelClose.addEventListener('click', closeDetail);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isDetail) closeDetail(); });

  /* ============ MOBILE: scrollable panorama + bottom sheet ============ */
  var mobile = section.querySelector('.filiera-mobile');
  var scrollEl = mobile.querySelector('.m-scroll');
  var panoEl = mobile.querySelector('.m-pano');
  var panoImg = panoEl.querySelector('img.photo');
  var mHotspotsEl = mobile.querySelector('.m-hotspots');
  var sheet = mobile.querySelector('.m-sheet');
  var sheetBackdrop = mobile.querySelector('.m-sheet-backdrop');
  var sheetClose = mobile.querySelector('.m-sheet__close');
  var edgeLeft = mobile.querySelector('.m-edge--left');
  var edgeRight = mobile.querySelector('.m-edge--right');
  var hint = mobile.querySelector('.m-hint');

  panoImg.src = photo.src;
  panoImg.alt = photo.alt;

  var mActiveIndex = 0, mIsDetail = false, syncingPano = false;

  var mHotspots = hotspots.map(function (h, i) {
    var mh = document.createElement('button');
    mh.className = 'm-hotspot';
    mh.style.left = h.dataset.fx + '%'; mh.style.top = h.dataset.fy + '%';
    mh.setAttribute('aria-label', h.dataset.title || '');
    mh.innerHTML = '<span class="m-hotspot__pulse"></span><span class="m-hotspot__ring"></span><span class="m-hotspot__core"></span>';
    mh.addEventListener('click', function () { openMobileDetail(i); });
    mHotspotsEl.appendChild(mh);
    return mh;
  });

  function selectMobile(i) {
    mActiveIndex = i;
    mHotspots.forEach(function (h, hi) { h.classList.toggle('is-active', hi === i); });
  }

  function centerPanoOn(i, animate) {
    var target = mHotspots[i].offsetLeft;
    var left = Math.max(0, Math.min(target - scrollEl.clientWidth / 2, scrollEl.scrollWidth - scrollEl.clientWidth));
    syncingPano = true;
    scrollEl.scrollTo({ left: left, behavior: animate ? 'smooth' : 'auto' });
    setTimeout(function () { syncingPano = false; }, animate ? 500 : 50);
  }

  function updateEdges() {
    var max = scrollEl.scrollWidth - scrollEl.clientWidth;
    edgeLeft.classList.toggle('is-visible', scrollEl.scrollLeft > 4);
    edgeRight.classList.toggle('is-visible', scrollEl.scrollLeft < max - 4);
  }

  var panoTicking = false;
  scrollEl.addEventListener('scroll', function () {
    updateEdges();
    if (syncingPano || panoTicking) return;
    panoTicking = true;
    requestAnimationFrame(function () {
      var center = scrollEl.scrollLeft + scrollEl.clientWidth / 2;
      var closest = 0, closestDist = Infinity;
      mHotspots.forEach(function (h, i) { var d = Math.abs(h.offsetLeft - center); if (d < closestDist) { closestDist = d; closest = i; } });
      if (closest !== mActiveIndex) selectMobile(closest);
      panoTicking = false;
    });
  }, { passive: true });
  scrollEl.addEventListener('pointerdown', function () { hint.classList.add('is-hidden'); }, { once: true });

  function fillSheetMedia(zone) {
    var mediaEl = mobile.querySelector('[data-sheet-media]');
    var tpl = section.querySelector('template[data-filiera-media="' + zone + '"]');
    mediaEl.innerHTML = '';
    if (tpl && tpl.content.firstElementChild) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      if (node.tagName === 'VIDEO') {
        var box = document.createElement('div'); box.className = 'm-video-box'; box.appendChild(node);
        var muteBtn = document.createElement('button');
        muteBtn.type = 'button';
        muteBtn.className = 'm-sheet__mute'; muteBtn.setAttribute('data-sheet-mute', '');
        setupMuteButton(muteBtn, node);
        box.appendChild(muteBtn);
        mediaEl.appendChild(box);
        playInlineMuted(node);
      } else { mediaEl.appendChild(node); }
    }
  }

  function openMobileDetail(i) {
    selectMobile(i);
    centerPanoOn(i, true);
    mIsDetail = true;
    var h = hotspots[i];
    mobile.querySelector('[data-sheet-eyebrow]').textContent = h.dataset.eyebrow || '';
    mobile.querySelector('[data-sheet-title]').textContent = h.dataset.title || '';
    mobile.querySelector('[data-sheet-body]').textContent = h.dataset.body || '';
    fillSheetMedia(h.dataset.zone);
    sheet.setAttribute('aria-hidden', 'false');
    sheetBackdrop.classList.add('is-open');
    sheet.classList.add('is-open');
  }

  function closeMobileDetail() {
    if (!mIsDetail) return;
    mIsDetail = false;
    sheet.querySelectorAll('video').forEach(function (video) { video.pause(); });
    sheet.setAttribute('aria-hidden', 'true');
    sheetBackdrop.classList.remove('is-open');
    sheet.classList.remove('is-open');
  }

  sheetClose.addEventListener('click', closeMobileDetail);
  sheetBackdrop.addEventListener('click', closeMobileDetail);

  function nudge() {
    var max = scrollEl.scrollWidth - scrollEl.clientWidth;
    if (max < 20 || getComputedStyle(mobile).display === 'none') return;
    syncingPano = true;
    var dist = Math.min(60, max * 0.25);
    var start = scrollEl.scrollLeft, t0 = null;
    function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / 900);
      var v = p < 0.5 ? ease(p * 2) / 2 : 1 - ease((1 - p) * 2) / 2;
      scrollEl.scrollLeft = start + dist * v;
      if (p < 1 && !mIsDetail) requestAnimationFrame(step); else { scrollEl.scrollLeft = start; syncingPano = false; }
    }
    requestAnimationFrame(step);
  }

  window.addEventListener('resize', function () { centerPanoOn(mActiveIndex, false); updateEdges(); });
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      selectMobile(0);
      scrollEl.scrollLeft = (scrollEl.scrollWidth - scrollEl.clientWidth) / 2;
      updateEdges();
      setTimeout(nudge, 500);
    });
  });
})();
